(function () {
  let scrollLocked = false;

  function lockPageScroll() {
    if (scrollLocked) return;
    scrollLocked = true;
    document.documentElement.classList.add('fab-policy-scroll-locked');
  }

  function unlockPageScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.documentElement.classList.remove('fab-policy-scroll-locked');
  }

  function hasOpenPolicyModal() {
    return Boolean(document.querySelector('[data-fab-policy-modal][open]'));
  }

  function closeModal(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  function openModal(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('[data-fab-policy-modal][open]').forEach((openDialog) => {
      if (openDialog !== dialog) closeModal(openDialog);
    });
    dialog.showModal();
    lockPageScroll();
    return true;
  }

  function openCookiePreferences() {
    document.querySelectorAll('[data-fab-policy-modal][open]').forEach((openDialog) => {
      closeModal(openDialog);
    });

    if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
      privacyBanner.showPreferences();
      return true;
    }

    return false;
  }

  function isCookiePreferencesTrigger(trigger) {
    if (!trigger) return false;
    if (trigger.hasAttribute('data-fab-cookie-preferences')) return true;
    const href = (trigger.getAttribute('href') || '').toLowerCase();
    return href.includes('shopifyreshowconsentbanner') || href.includes('#shopify');
  }

  function initPolicyModals(root) {
    root.querySelectorAll('[data-fab-cookie-preferences], .fab-footer__policy-link[href*="shopifyReshowConsentBanner"], .fab-footer__policy-link[href*="#shopify"]').forEach((trigger) => {
      if (trigger.dataset.fabPolicyBound === 'true') return;
      trigger.dataset.fabPolicyBound = 'true';
      trigger.setAttribute('data-fab-cookie-preferences', '');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (!openCookiePreferences()) {
          window.setTimeout(openCookiePreferences, 400);
        }
      });
    });

    root.querySelectorAll('[data-fab-policy-open]').forEach((trigger) => {
      if (trigger.dataset.fabPolicyBound === 'true') return;
      if (isCookiePreferencesTrigger(trigger)) return;
      trigger.dataset.fabPolicyBound = 'true';

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const dialogId = trigger.getAttribute('data-fab-policy-open');
        const dialog = dialogId ? document.getElementById(dialogId) : null;
        if (!openModal(dialog)) {
          const fallback = trigger.getAttribute('href') || trigger.getAttribute('data-fab-policy-fallback');
          if (fallback) window.location.href = fallback;
        }
      });
    });

    root.querySelectorAll('[data-fab-policy-modal]').forEach((dialog) => {
      if (dialog.dataset.fabPolicyBound === 'true') return;
      dialog.dataset.fabPolicyBound = 'true';

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeModal(dialog);
      });

      dialog.querySelectorAll('[data-fab-policy-close]').forEach((button) => {
        button.addEventListener('click', () => closeModal(dialog));
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeModal(dialog);
      });

      dialog.addEventListener('close', () => {
        if (!hasOpenPolicyModal()) {
          unlockPageScroll();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPolicyModals(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) initPolicyModals(event.target);
  });
})();
